import React, { useState } from "react";
import { Placeholder, Image } from "semantic-ui-react";

const ContentImage = ({ imageUrl, imageBytes }) => {
  const [loading, setLoading] = useState(true);

  const imageLoaded = () => {
    setLoading(false);
  };

  return (
    <>
      <Placeholder
        className="box-image"
        style={{ display: loading ? "block" : "none", height: 400, width: 400 }}
      >
        <Placeholder />
      </Placeholder>
      <Image
        style={{ display: !loading ? "block" : "none" }}
        as="a"
        // href={imageUrl}
        target="_blank"
        rel="noopener noreferrer"
        src={"data:image/png;base64, " + imageBytes}
        className="box-image"
        onLoad={() => imageLoaded()}
      />
    </>
  );
};

export default ContentImage;
